import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, AfterViewInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { TTButton } from '../teiasoft-toolbar/teiasoft-toolbar.component';
import { Globals } from '../../globals/globals';
import { ODataGridFilter, ODataGridFilterMap } from '../teiasoft-grid-odata/teiasoft-grid-odata.component';
import { TranslateService } from '@ngx-translate/core';
import { GlobalClickService } from '../../services/global-click/global-click.service';
import { cloneDeep, isEqual } from 'lodash';
declare var $: any;

@Component({
  selector: 'teiasoft-select-options',
  templateUrl: './teiasoft-select-options.component.html',
  styleUrls: ['./teiasoft-select-options.component.scss']
})


export class TeiasoftSelectOptionsComponent implements OnInit, OnChanges, OnDestroy {
  private readonly closeOnScrollHandler = () => {
    if (!this.isOpen) return;
    this.onCancelClick();
  };

  @Input() labelText: string = "";
  @Input() disabled: boolean = false;
  @Input() spaceLabel: boolean = false;
  @Input() noMinWidth: boolean = false;
  @Input() clearValue: boolean = false;
  @Input() inputValues: any[] = new Array();
  @Input() colName: string = "";
  @Input() oDataFilterMaps: ODataGridFilterMap[] = new Array();
  @Input() preselectedValues: string[] = new Array();
  @Input() tabIndex: number = -1;
  @Input() isRequired: boolean = false;


  @Output() onSelectedFilterOptions: EventEmitter<any[]> = new EventEmitter();

  @ViewChild('inputWrapper') inputWrapper!: ElementRef;


  selectId: string = "";
  optionId: string = "";
  value: string = "";
  isOpen: boolean = false;
  startValues: any[] = new Array();
  selectedValues: any[] = new Array();
  buttonsList: TTButton[] = new Array();
  optTop: number = 0;
  optLeft: number = 0;
  dropdownWidth: number = 0;
  values: string[] = new Array();
  filteredValues: string[] = new Array();
  oldSelectedValues: string[] = new Array();
  clickListener!: (evt: any) => void;

  constructor(public globals: Globals, private translate: TranslateService, private globalClickService: GlobalClickService) {
    this.globalClickService.registerComponent(this);

    this.manageSelectId();
    //this.buildButtonsList();
  }

  ngOnInit(): void {
    $('.tg-cnt-ext').scroll(() => {
      this.isOpen = false;
    });
    document.addEventListener('teiasoft-close-floating-dropdowns', this.closeOnScrollHandler);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["colName"]) {
      if (changes["colName"].currentValue != undefined && changes["colName"].currentValue != null) {
        this.colName = changes["colName"].currentValue;
        this.getValues();
      }
    }

    if (changes && changes["oDataFilterMaps"]) {
      this.oDataFilterMaps = new Array();
      this.oDataFilterMaps = changes["oDataFilterMaps"].currentValue;
    }

    if (changes && changes["clearValue"]) {
      this.clearValue = changes["clearValue"].currentValue;
      if (this.clearValue) {
        this.value = '';
        this.filteredValues = cloneDeep(this.values);
        this.selectedValues = cloneDeep(this.values);
        this.oldSelectedValues = cloneDeep(this.values);
        $('.' + this.selectId).val('');
      }
    }

    if (changes && changes["inputValues"]) {
      if (changes["inputValues"].currentValue != undefined && changes["inputValues"].currentValue != null) {
        this.startValues = new Array();
        this.startValues = changes["inputValues"].currentValue;
        this.getValues();
        this.oldSelectedValues = new Array();
        this.oldSelectedValues = cloneDeep(this.selectedValues);
      }
    }

    if (changes && changes["preselectedValues"]) {
      const currentPreselectedValues = changes["preselectedValues"].currentValue || [];
      const previousPreselectedValues = changes["preselectedValues"].previousValue || [];
      const hasMeaningfulChange = changes["preselectedValues"].firstChange || !isEqual(currentPreselectedValues, previousPreselectedValues);
      this.preselectedValues = currentPreselectedValues;
      if (hasMeaningfulChange) this.applyPresetSelection();
    }
  }

  ngOnDestroy(): void {
    document.removeEventListener('teiasoft-close-floating-dropdowns', this.closeOnScrollHandler);
    this.globalClickService.unregisterComponent(this);
    this.removeIdFromSessionStorage("TS-SELECT-OPTIONS", this.selectId);
    this.removeIdFromSessionStorage("TS-SELECT-OPTIONS-LIST", this.optionId);
  }

  handleClickOutside(event: Event) {
    const target = event.target as HTMLElement | null;
    if (!target) {
      return;
    }

    const optionsEl = document.getElementById(this.optionId);
    if (optionsEl && optionsEl.contains(target)) {
      return;
    }

    const selectEl = document.getElementById(this.selectId);
    if (selectEl && selectEl.contains(target)) {
      return;
    }

    if (this.isOpen) {
      this.onCancelClick();
    }
  }

  /* METHODS */
  buildButtonsList() {
    this.buttonsList = new Array();
    let _item: TTButton = new TTButton();

    _item = new TTButton();
    _item.disabled = false;
    _item.icon = '';
    _item.id = 0;
    _item.size = "";
    _item.text = "ok";
    _item.tooltip = "ok";
    _item.action = "ok";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    _item = new TTButton();
    _item.disabled = false;
    _item.icon = '';
    _item.id = 1;
    _item.size = "";
    _item.text = "cancel";
    _item.tooltip = "cancel";
    _item.action = "cancel";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

  }

  getValues() {
    if (this.colName == '' || this.startValues == undefined || this.startValues.length == 0) return;
    if (!this.oDataFilterMaps || this.oDataFilterMaps.length == 0) return;
    this.values = new Array();
    for (const prop in this.startValues) {
      let _map: string = this.oDataFilterMaps.filter(x => x.columnName!.toLowerCase() == this.colName.toLowerCase())[0].filterName!;
      if (prop.toLowerCase() == _map.toLowerCase()) {
        this.values = this.startValues[prop];
      }
    }

    this.filteredValues = cloneDeep(this.values);
    this.applyPresetSelection();
  }

  private applyPresetSelection() {
    if (!this.values || this.values.length == 0) {
      this.selectedValues = new Array();
      this.oldSelectedValues = new Array();
      return;
    }

    const normalizedPresets = (this.preselectedValues || [])
      .map(value => (value ?? '').toString().trim())
      .filter(value => value != '');

    if (normalizedPresets.length == 0) {
      // Default behavior: as in Excel, all values are selected
      this.selectedValues = cloneDeep(this.values);
      this.oldSelectedValues = cloneDeep(this.selectedValues);
      return;
    }

    const selectedValues: string[] = new Array();
    const selectedSet = new Set<string>();
    for (const value of this.values) {
      const normalizedValue = (value ?? '').toString().trim();
      if (normalizedValue == '') continue;

      // compare sanitized values: this.values holds OData-escaped quotes ('') while applied filters hold plain ones (')
      const sanitizedValue = this.sanitizeString(normalizedValue).toLowerCase();
      const existsInPreset = normalizedPresets.findIndex(preset => this.sanitizeString(preset).toLowerCase() == sanitizedValue) != -1;
      if (!existsInPreset) continue;

      const dedupeKey = normalizedValue.toLowerCase();
      if (selectedSet.has(dedupeKey)) continue;
      selectedSet.add(dedupeKey);
      selectedValues.push(value);
    }

    if (selectedValues.length == 0) {
      this.selectedValues = cloneDeep(this.values);
      this.oldSelectedValues = cloneDeep(this.selectedValues);
      return;
    }

    this.selectedValues = selectedValues;
    this.oldSelectedValues = cloneDeep(this.selectedValues);
  }

  manageSelectId() {
    let _list: string[] = new Array();
    if (sessionStorage.getItem("TS-SELECT-OPTIONS")) {
      _list = sessionStorage.getItem("TS-SELECT-OPTIONS")!.split(",");
      if (_list.length == 999999) {
        _list = new Array();
        sessionStorage.removeItem("TS-SELECT-OPTIONS");
      }
    }
    let x = this.getRandomInt(0, 999999);
    if (_list && _list.length > 0) {
      while (_list.findIndex(t => t == "TS_OPT_" + x.toString()) != -1) {
        let x = this.getRandomInt(0, 999999);
        if (_list.findIndex(t => t == "TS_OPT_" + x.toString()) == -1) break;
      }
    } else {
      _list = new Array();
    }
    _list.push("TS_OPT_" + x.toString());
    sessionStorage.setItem("TS-SELECT-OPTIONS", _list.join(","));
    this.selectId = "TS_OPT_" + x.toString();
    this.manageListId();
  }

  manageListId() {
    let _list: string[] = new Array();
    if (sessionStorage.getItem("TS-SELECT-OPTIONS-LIST")) {
      _list = sessionStorage.getItem("TS-SELECT-OPTIONS-LIST")!.split(",");
      if (_list.length == 999999) {
        _list = new Array();
        sessionStorage.removeItem("TS-SELECT-OPTIONS-LIST");
      }
    }
    let x = this.getRandomInt(0, 999999);
    if (_list && _list.length > 0) {
      while (_list.findIndex(t => t == "TS_OPT_LIST_" + x.toString()) != -1) {
        let x = this.getRandomInt(0, 999999);
        if (_list.findIndex(t => t == "TS_OPT_LIST_" + x.toString()) == -1) break;
      }
    } else {
      _list = new Array();
    }
    _list.push("TS_OPT_LIST_" + x.toString());
    sessionStorage.setItem("TS-SELECT-OPTIONS-LIST", _list.join(","));
    this.optionId = "TS_OPT_LIST_" + x.toString();
  }

  getRandomInt(min: number, max: number): number {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  private removeIdFromSessionStorage(storageKey: string, id: string): void {
    if (!id) {
      return;
    }

    const stored = sessionStorage.getItem(storageKey);
    if (!stored) {
      return;
    }

    const updated = stored.split(',').filter(item => item && item !== id);
    if (updated.length > 0) {
      sessionStorage.setItem(storageKey, updated.join(','));
    } else {
      sessionStorage.removeItem(storageKey);
    }
  }

  onOpenClose(evt: any) {
    const rect = this.inputWrapper.nativeElement.getBoundingClientRect();
    const computedStyle = window.getComputedStyle(this.inputWrapper.nativeElement);

    // Get the padding and border values
    const borderLeftWidth = parseFloat(computedStyle.borderLeftWidth);
    const borderRightWidth = parseFloat(computedStyle.borderRightWidth);
    
    // Calculate the content width (rect.width excludes margins, so no need to subtract those)
    const contentWidth = rect.width - borderLeftWidth - borderRightWidth;

    this.optTop = rect.bottom; // Position below the input
    this.optLeft = rect.left;  // Align to the input
    this.dropdownWidth = contentWidth;
    this.isOpen = !this.isOpen;

    $('.' + this.selectId).focus();
  }

  /* EVENTS */
  onInputChange(evt: any) {
    let _str: string = evt.target.value;
    this.value = _str;
    if (_str != '') {
      this.filteredValues = this.values.filter(x => x.toLowerCase().includes(_str.toLowerCase()));
      this.selectedValues = cloneDeep(this.filteredValues); // Avoids adding quotes
    } else {
      this.getValues();
    }
  }

  onKeyDown(evt: KeyboardEvent){
    if(evt.key == 'Enter'){
      this.onOkClick();
    }
  }

  sanitizeString(value: string): string {
    return value.replace(/''/g, "'"); // Replace double single-quotes with a single one
  }

  onSelectAll(evt?: any) {
    const targetChecked = evt?.target?.checked;
    const isAllSelected = this.selectedValues?.length === this.filteredValues?.length;
    const shouldSelectAll = typeof targetChecked === 'boolean' ? targetChecked : !isAllSelected;
    const valuesToSelect = (this.filteredValues && this.filteredValues.length > 0)
      ? this.filteredValues
      : this.values;

    if (shouldSelectAll) {
      this.selectedValues = cloneDeep(valuesToSelect);
    } else {
      this.selectedValues = new Array();
    }
  }

  onSelectDeselect(value: string) {
    let _checked: boolean = false;
    if (!this.selectedValues) {
      this.selectedValues = new Array();
      _checked = false;
    } else {
      _checked = this.selectedValues.indexOf(value) != -1;
    }
    if (_checked == false) {
      this.selectedValues.push(value);
    } else {
      this.selectedValues = this.selectedValues.filter(x => x != value);
    }
  }

  imChecked(value: string): boolean {
    return (this.selectedValues && this.selectedValues.some(x => x == value));
  }

  onOkClick() {
    const sanitizedValues = this.selectedValues.map(this.sanitizeString);
    if (sanitizedValues.length < this.values.length) {
      this.onSelectedFilterOptions.emit(sanitizedValues);
    } else {
      this.onSelectedFilterOptions.emit([]);
    }

    // commit the applied selection so a later cancel restores it
    this.oldSelectedValues = cloneDeep(this.selectedValues);
    this.resetSearch();
    this.isOpen = false;
  }

  onCancelClick() {
    // recover the stored selection on cancel
    this.selectedValues = cloneDeep(this.oldSelectedValues);
    this.resetSearch();
    this.isOpen = false;
  }

  // closing the dropdown must not keep the search text/filtered list around
  private resetSearch() {
    this.value = '';
    this.filteredValues = cloneDeep(this.values);
    $('.' + this.selectId).val('');
  }

  getPlaceHolder(): string {
    if (!this.isOpen) return this.translate.instant('grid.openListToSearch');
    return '';
  }
}
